import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  buildUrl({ pricingType, targetPath }) {
    const origin = window.location.origin
    const pathParts = window.location.pathname.split("/")
    pathParts.pop()
    pathParts.push(targetPath)

    const pathName = pathParts.join("/")
    const params = new URLSearchParams(window.location.search)

    return `${origin}${pathName}?${this.buildUrlParams(pricingType)}`
  }

  buildUrlParams(pricingType = null) {
    const params = new URLSearchParams(window.location.search)

    if (pricingType) {
      params.append("payment_method", pricingType)
    } else if (document.querySelector("#cc") && document.querySelector("#cc").checked) {
      params.append("payment_method", "credit")
    } else if (document.querySelector("#ach") && document.querySelector("#ach").checked) {
      params.append("payment_method", "ach")
    }

    const billing_interval_id = document.querySelector("#rental_billing_interval_id").value
    params.append("rental[billing_interval_id]", billing_interval_id)

    const selected_protection_plan_input = document.querySelector(
      "input[name='rental[protection_plan_option_id]']:checked"
    )
    if (selected_protection_plan_input) {
      params.append("rental[protection_plan_option_id]", selected_protection_plan_input.value)
    }
    const property_description_input = document.querySelector("#rental_property_description")
    if (property_description_input) {
      params.append("rental[property_description]", property_description_input.value)
    }
    const insurance_file_input = document.querySelector(
      "fieldset > input[name='rental[insurance_file]']"
    )
    if (insurance_file_input) {
      params.append("rental[insurance_file]", insurance_file_input.value)
    }

    const discountCodeInput = document.querySelector("input[name='discount_code']")
    if (discountCodeInput) {
      params.append("discount_code", discountCodeInput.value)
    }
    const discountIdInput = document.querySelector("input[name='rental[discount_id]']")
    if (discountIdInput) {
      params.append("rental[discount_id]", discountIdInput.value)
    }

    return params.toString()
  }

  doReloadProtectionPlan(pricingType) {
    const turboFrame = document.getElementById("protection_plan")

    if (!turboFrame) return

    turboFrame.src = this.buildUrl({
      pricingType,
      targetPath: "protection_plan.turbo_stream",
    })
  }

  doReloadSummary(pricingType) {
    const turboFrame = document.getElementById("summary")

    if (!turboFrame) return

    turboFrame.src = this.buildUrl({ pricingType, targetPath: "summary.turbo_stream" })
  }

  reloadDiscount(e) {
    e.preventDefault()

    const turboFrame = document.getElementById("discount")
    if (!turboFrame) return

    const discountCodeInput = turboFrame.querySelector("input[name='discount_code']")
    if (e.target.id !== "rental_billing_interval_id" && discountCodeInput && !discountCodeInput.value.trim()) return

    turboFrame.src = this.buildUrl({ targetPath: "apply_discount.turbo_stream" })
  }

  reloadProtectionPlan() {
    this.doReloadProtectionPlan()
  }

  reloadProtectionPlanWithAchPricing() {
    this.doReloadProtectionPlan("ach")
  }

  reloadProtectionPlanWithCardPricing() {
    this.doReloadProtectionPlan("credit")
  }

  reloadSummary() {
    this.doReloadSummary()
  }

  reloadSummaryWithAchPricing() {
    this.doReloadSummary("ach")
  }

  reloadSummaryWithCardPricing() {
    this.doReloadSummary("credit")
  }
}
